import detailsData from './detailsData';

import { useRef, useEffect } from 'react';
import gsap from 'gsap';

import { useNavigate } from 'react-router-dom';

function DetailsBestInCategories({ selectedCategoryId }) {
  const navigate = useNavigate();

  // creating array references
  const detailsImageAnimation = useRef([]);

  // adding elements inside the array ref
  const addToRefs = (ele) => {
    if (ele && !detailsImageAnimation.current.includes(ele)) {
      detailsImageAnimation.current.push(ele);
    }
  };

  useEffect(() => {
    gsap.fromTo(
      detailsImageAnimation.current,
      {
        scale: 0.5,
        opacity: 0,
      },
      {
        scale: 1,
        opacity: 1,
        duration: 0.6,
        ease: "back.out(1.7)",
        stagger: 0.1,
      }
    );
  }, [selectedCategoryId]);

  const selectedProducts = detailsData[selectedCategoryId] || [];

  return (
    <div className="DetailsBestInCategories">
      {/* Main Product */}
      <div
        className="big-product glass-product-card"
        onClick={() => {
          navigate(selectedProducts[0].path, {state: { from: 'BestInCategory' }});
        }}
      >
        {!selectedProducts ? (
          <div>loading</div>
        ) : (
          <>
            <div className="big-product-container">
              <div className="big-product-img-container" ref={addToRefs}>
                <img
                  className="big-img"
                  src={selectedProducts[0].img}
                  alt="Product"
                />
              </div>
            </div>

            <div className="product-details">
              <p className="product-details-title">
                {selectedProducts[0].name}
              </p>
              {selectedProducts[0].extraline && (
                <p className={`product-details-extraline ${selectedProducts[0].highlightPrice ? 'product-details-effective-price' : ''}`}>
                  {selectedProducts[0].extraline}
                </p>
              )}
              {selectedProducts[0].mrp && (
                <p className="product-details-mrp">
                  {selectedProducts[0].mrp}
                </p>
              )}

              {selectedProducts[0].EMIline &&
                (() => {
                  const [beforePrice, priceAndAfter] =
                    selectedProducts[0].EMIline.split('₹');

                  if (!priceAndAfter)
                    return (
                      <p
                        className={`product-details-emi ${selectedProducts[0].highlightPrice ? 'product-details-offer-note' : ''}`}
                      >
                        {selectedProducts[0].EMIline}
                      </p>
                    );
                  const [price, ...afterParts] = priceAndAfter.split(' ');
                  const afterText = afterParts.join(' ');

                  return (
                    <p className="product-details-emi">
                      {beforePrice}
                      <strong style={{ color: '#4a90e2' }}>₹{price}</strong> {afterText}
                    </p>
                  );
                })()}
            </div>
          </>
        )}
      </div>

      {/* Small Products */}
      {selectedProducts.slice(1).map((product, index) => {
        return (
          <div
            key={index}
            className="small-section-btc glass-product-card"
            onClick={() => {
              navigate(product.path, {state: { from: 'BestInCategory' }});
            }}
          >
            <div className="small-img-container" ref={addToRefs}>
              <img
                className="small-img"
                src={product.img}
                alt="Product"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
            <div className="product-details">
              <p className="product-details-small-title">
                {product.name}
              </p>
              {product.extraline && (
                <p className="product-details-small-extra">
                  {product.extraline}
                </p>
              )}
              {product.mrp && (
                <p className="product-details-small-mrp">
                  {product.mrp}
                </p>
              )}

              {product.EMIline &&
                (() => {
                  const [beforePrice, priceAndAfter] =
                    product.EMIline.split('₹');

                  if (!priceAndAfter)
                    return (
                      <p className="product-details-small-emi">
                        {product.EMIline}
                      </p>
                    );
                  const [price, ...afterParts] = priceAndAfter.split(' ');
                  const afterText = afterParts.join(' ');

                  return (
                    <p className="product-details-small-emi">
                      {beforePrice}
                      <strong style={{ color: '#4a90e2' }}>₹{price}</strong> {afterText}
                    </p>
                  );
                })()}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default DetailsBestInCategories;
